import { render, staticRenderFns } from "./GuestInfoStateroom.vue?vue&type=template&id=22d72c27&scoped=true"
import script from "./GuestInfoStateroom.vue?vue&type=script&lang=js"
export * from "./GuestInfoStateroom.vue?vue&type=script&lang=js"
import style0 from "./GuestInfoStateroom.vue?vue&type=style&index=0&id=22d72c27&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d72c27",
  null
  
)

export default component.exports